export default "__VITE_ASSET__BPAjpIIW__"